import { Controller } from 'stimulus';
import RequestQueue from '../classes/RequestQueue';

class RadioController extends Controller {
  static targets = [
    'option'
  ]

  connect() {
    const initialActiveIndex = this.data.get('activeIndex');
    this.__resetOptionClasses();
    if (initialActiveIndex) {
      this.optionTargets.forEach((option, index) => {
        if (parseInt(initialActiveIndex) == index) {
          option.className = option.getAttribute('data-radio-active-classes')
        }
      })
    }
  }

  selectOption = async e => {
    e.preventDefault();
    e.stopPropagation();
    const optionElement = e.target;
    const url = optionElement.getAttribute('data-radio-request-url');
    const urlMethod = optionElement.getAttribute('data-radio-request-method');
    const requestData = optionElement.getAttribute('data-radio-request-data');

    const { data } = await RequestQueue.addToQueue({
      url,
      method: urlMethod,
      data: requestData
    })
    if (data.status === 'success') {
      this.__resetOptionClasses();
      optionElement.className = optionElement.getAttribute('data-radio-active-classes')
    }
  }

  __resetOptionClasses = () => {
    this.optionTargets.forEach(option => {
      option.className = option.getAttribute('data-radio-inactive-classes')
    })
  }
}

export default RadioController;
